import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

function Unauthorized() {
    const navigate = useNavigate();
    const location = useLocation();
    const message =
        location?.state?.message ||
        "You are not authorized to access this page. Please login to continue.";

    return (
        <div className="unauthorized-container" >
            <div className="unauthorized-content">
                <h2 style={{ marginBottom: "12px", color: "#b42318" }}>Unauthorized Access</h2>
                <p style={{ marginBottom: "24px", color: "#374151" }}>{message}</p>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => navigate("/", { replace: true })}
                >
                    Go to Login
                </button>
            </div>
        </div>
    );
}

export default Unauthorized;
